import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  theme: 'light'  // Stati possibili: 'light', 'dark'
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    cycleTheme: (state, action) => {
      const direction = action.payload; // 'left' o 'right'
      
      // Se siamo in neutral (stato iniziale), comportamento normale
      if (state.theme === 'neutral') {
        if (direction === 'left') {
          state.theme = 'code';
        } else if (direction === 'right') {
          state.theme = 'design';
        }
      } 
      // Se siamo in code o design, passa direttamente all'altro tema
      else if (state.theme === 'code' && direction === 'right') {
        state.theme = 'design';
      } else if (state.theme === 'design' && direction === 'left') {
        state.theme = 'code';
      }
      // Altrimenti non fare nulla (già al limite)
    }
  }
});

export const { setTheme, cycleTheme } = themeSlice.actions;

// Selectors
export const selectTheme = (state) => state.theme.theme;

export default themeSlice.reducer;